import * as React from 'react';
import { flexTooltipHost, svgIconStyles } from '../../../../styles/iconStyles';
import { TooltipHost } from '@fluentui/react';
import { LanguageContext } from '../../../../../../utilities/LocalizationModule';

export const ChannelPrivateIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    const languageStrings = React.useContext(LanguageContext);

    return <TooltipHost content={languageStrings.Private} styles={flexTooltipHost}>
        <svg role="presentation" focusable="false" aria-hidden viewBox="0 0 20 20" width={16} height={16} fill="currentColor" style={{ ...props.style, ...svgIconStyles, marginTop: 1 }}>
            <path
                d="M10 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM6 6h1V5a3 3 0 0 1 6 0v1h1a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3Zm4-3a2 2 0 0 0-2 2v1h4V5a2 2 0 0 0-2-2Zm6 6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V9Z"
                fill="currentColor"
            />
        </svg>
    </TooltipHost>
}